module.exports = __webpack_public_path__ + "static/right. based on science-793883d042de80791a52e47587ea508e.jpg";